import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export type DoNotBuyEntryRecord = QueryAtomResult<
  typeof queryDoNotBuyEntriesAtom
>[number];

export const queryDoNotBuyEntriesAtom = createQueryAtomFactory(
  'settings.doNotBuyEntries',
  () => ({
    doNotBuyEntries: {
      __args: {
        pagination: {
          offset: 0,
          limit: 100,
        },
      },
      entries: {
        id: true,
        accountId: true,
        facilityId: true,
        reason: true,
        status: true,
        originType: true,
        effectiveFrom: true,
        effectiveTo: true,
        addedByUserId: true,
        removedByUserId: true,
        notes: true,
        account: {
          id: true,
          name: true,
        },
        facility: {
          id: true,
          facilityName: true,
        },
        addedByUser: {
          id: true,
          firstName: true,
          lastName: true,
        },
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    },
  }),
  {
    select: (data) =>
      data?.doNotBuyEntries.entries.map((entry) => ({
        id: entry.id,
        accountId: entry.accountId,
        accountName: entry.account?.name,
        facilityId: entry.facilityId,
        facilityName: entry.facility?.facilityName,
        reason: entry.reason,
        status: entry.status,
        originType: entry.originType,
        effectiveFrom: entry.effectiveFrom,
        effectiveTo: entry.effectiveTo,
        addedByUserId: entry.addedByUserId,
        addedByUserName: entry.addedByUser
          ? `${entry.addedByUser.firstName} ${entry.addedByUser.lastName}`.trim()
          : undefined,
        removedByUserId: entry.removedByUserId,
        notes: entry.notes,
        createdAt: entry.timestamps.createdAt,
        updatedAt: entry.timestamps.updatedAt,
      })) ?? [],
  },
);
